import useTracker from "components/CTracker/useTrackerContext";

function FsdAndConfScorePassed() {
  const { loan } = useTracker();
  const minConfScoreAllowed = 80;
  const maxFsdAllowed = 0.2;

  if (
    loan?.borrowerSteps?.homeValuationVerification?.confidenceScore !==
      undefined &&
    loan?.borrowerSteps?.homeValuationVerification?.fsd !== undefined &&
    loan?.borrowerSteps?.homeValuationVerification?.confidenceScore2 !==
      undefined &&
    loan?.borrowerSteps?.homeValuationVerification?.fsd2 !== undefined
  ) {
    const bothTestsPassed =
      loan?.borrowerSteps?.homeValuationVerification?.confidenceScore >=
        minConfScoreAllowed &&
      loan?.borrowerSteps?.homeValuationVerification?.fsd <= maxFsdAllowed &&
      loan?.borrowerSteps?.homeValuationVerification?.confidenceScore2 >=
        minConfScoreAllowed &&
      loan?.borrowerSteps?.homeValuationVerification?.fsd2 <= maxFsdAllowed
        ? true
        : false;

    return bothTestsPassed;
  } else {
    return "Either FSD or Confidence Score are undefined";
  }
}

export default FsdAndConfScorePassed;
